import axios from "axios"
import useJwt from "@src/auth/jwt/useJwt"
import { videoInstance, videoInstanceCheck, videoInstanceDelete } from "./videoinstance"
import { toast } from "react-toastify"
import Swal from "sweetalert2"
import FileSaver from "file-saver"
import { store } from "@store/storeConfig/store"
const config = useJwt.jwtConfig

const t = (id) => {
  const messages = store.getState().config?.languageWords
  return messages?.[id] || id
}

const getConfig = () => axios.get(`${config.url}/admin/config`)

const postConfig = (key, value) => axios.post(`${config.url}/admin/config/ntface`, { key, value })

const getMahallas = (district_id) => axios.get(`${config.url}/df-datas/mahalla-by-district?id=${district_id}`)

const getServices = (user_id) => axios.get(`${config.url}/admin/parent-services/${user_id}`)

const downloadStreamer = async () => {
  try {
    const result = await axios.get(`${config.url}/s3/application/download?fileName=QalqonStreamerSetup`, { responseType: "arraybuffer" })
    if (result) {
      if (result.status === 200) {
        const blob = new Blob([result.data])
        FileSaver.saveAs(blob, `QalqonStreamerSetup.msi`)
        Swal.fire({
          title: `${t("Downloaded")}!`,
          text: `${t("YourFileHasBeenDownloaded")}.`,
          icon: "success",
          background: "linear-gradient(0deg, rgba(10,24,57,1) 0%, rgba(3,42,214,1) 100%)",
          customClass: {
            confirmButton: "btn btn-success"
          }
        })
      } else toast.error("Юклаб олишда хатолик юз берди")
    }
    return result
  } catch (err) {
    Swal.fire({
      title: `${t("DownloadFailed")}!`,
      text: `${t("FileDownloadFailed")}.`,
      icon: "error",
      background: "linear-gradient(0deg, rgba(10,24,57,1) 0%, rgba(3,42,214,1) 100%)",
      customClass: {
        confirmButton: "btn btn-success"
      }
    })
    return err.response
  }
}

const playBack = async (camera) => {
  try {
    const result = await videoInstance("http://localhost:37778/media/playback_v2", {
      ip: camera.camera_type === "bus" ? camera.camera_ip : camera.ivss_address,
      port: "37777",
      user: "admin",
      channel_id: camera.camera_type === "bus" ? camera.camera_channel - 1 : camera.channel_id - 1,
      password: camera.camera_type === "bus" ? "admin123" : "parol12345"
    })
    return result
  } catch (err) {}
}

const instance = axios.create()
delete instance.defaults.headers.common["Authorization"]

const streamStatus = async () => {
  let status, version
  try {
    const { data } = await instance.get(`http://localhost:37778/version`)
    if (data) {
      if (data.data) version = data.data
      if (data.status) status = "working"
      else status = "error"
    }
  } catch (err) {
    if (err.message === "Network Error") status = "Network Error"
  }
  return { status, version }
}

const getDistricts = () => axios.get(`${config.url}/districts/list`)

const getUrlForStream = (objectId, routeName) => axios.get(`${config.url}/df-datas/stream/${objectId}`, { params: { routeName } })

const getUrlForStreamPerimeter = (objectId) => axios.get(`${config.url}/foreign/perimeter/stream/${objectId}`)

const getUrlForStreamTadbirkor = (direction) => axios.get(`${config.url}/foreign/car/businesses/stream`, { params: { direction } })

const getUrlForStreamBus = (objectId, routeName) => axios.get(`${config.url}/df-datas/bus/stream/${objectId}`)

const closeStream = async (title) => await videoInstanceDelete(`http://localhost:37778/media/close`, title)

const checkStream = async (title) => await videoInstanceCheck(`http://localhost:37778/media/check`, title)

const streamVersion = async (version, appName) => axios.post(`${config.url}/s3/application/check-for-updates`, { appName: appName ? appName : "QalqonStreamerSetup", version, type: "msi" })

export const configApi = {
  getConfig,
  postConfig,
  getMahallas,
  getServices,
  playBack,
  streamStatus,
  downloadStreamer,
  getDistricts,
  closeStream,
  checkStream,
  streamVersion,
  getUrlForStream,
  getUrlForStreamPerimeter,
  getUrlForStreamTadbirkor,
  getUrlForStreamBus
}
